module.exports = __webpack_public_path__ + "static/media/sms-alert.a55a75f1.mp3";